// @flow

import { defaults } from 'lodash';

import { API_CALL, START_API_POLL, STOP_API_POLL } from '../constants/actionTypes';
import * as pollDurations from '../constants/pollDurations';

type QueryOptions = {
  poll?: boolean,
  runStraightAway?: boolean,
  duration?: number,
  key: string,
  quietPoll?: boolean,
  quiet?: boolean,
  query: (o: Object) => Promise<*>,
  queryParams: Object
};

function parseOptions(options: QueryOptions = {}): QueryOptions {
  return defaults(options, {
    poll: true,
    duration: pollDurations.OPEN_CHALLENGE_POLL_DURATION,
    quietPoll: true
  });
}

export function sendQuery(rawOptions: Object) {
  const options = parseOptions(rawOptions);

  return (dispatch: Dispatch<*>) => {
    if (options.runStraightAway || !options.poll) {
      dispatch({
        type: API_CALL,
        api: options.key,
        request: options.query(options.queryParams),
        quiet: options.quiet
      });
    }
    if (options.poll) {
      dispatch({
        type: START_API_POLL,
        key: options.key,
        duration: options.duration,
        getApiCall: () => ({
          api: options.key,
          request: () => options.query(options.queryParams),
          quiet: options.quietPoll
        })
      });
    }
  };
}

export function stopChallengePolls(keys: Array<string> | string = []) {
  return {
    type: STOP_API_POLL,
    keys: Array.isArray(keys) ? keys : [keys]
  };
}
